<div class="basic-chart-root">
  @switch(type) {
    @case('bar') {
      <div class="chart-frame">
        <svg viewBox="0 0 100 70" preserveAspectRatio="xMidYMid meet" class="chart-svg">
          @for (v of normalized; track $index) {
            @let i = $index;
            <g>
              <rect
                [attr.x]="(i * (100 / normalized.length)) + 2"
                [attr.y]="60 - (v * 48) - 8"
                [attr.width]="(100 / normalized.length) - 6"
                [attr.height]="v * 48"
                class="bar"
              />
              <text
                class="bar-value"
                [attr.x]="(i * (100 / normalized.length)) + 2 + ((100 / normalized.length) - 6) / 2"
                [attr.y]="60 - (v * 48) - 12"
                text-anchor="middle"
              >
                {{ data.values && data.values[i] !== undefined ? data.values[i] : '' }}
              </text>
              <text
                class="bar-label"
                [attr.x]="(i * (100 / normalized.length)) + 2 + ((100 / normalized.length) - 6) / 2"
                [attr.y]="66"
                text-anchor="middle"
              >
                {{ data.labels && data.labels[i] ? data.labels[i] : '' }}
              </text>
            </g>
          }
        </svg>
      </div>
    }

    @case('line') {
      <div class="chart-frame">
        <svg viewBox="0 0 100 70" preserveAspectRatio="xMidYMid meet" class="chart-svg">
          <polyline [attr.points]="linePoints" class="line" />
          @for (v of normalized; track $index) {
            @let i = $index;
            <g>
              <circle
                [attr.cx]="(i/(normalized.length-1 || 1))*100"
                [attr.cy]="60 - (v*48) - 8"
                r="1.2"
                class="dot"
              />
              <text
                class="line-value"
                [attr.x]="(i/(normalized.length-1 || 1))*100"
                [attr.y]="(60 - (v*48) - 12)"
                text-anchor="middle"
              >
                {{ data.values && data.values[i] !== undefined ? data.values[i] : '' }}
              </text>
              <text
                class="line-label"
                [attr.x]="(i/(normalized.length-1 || 1))*100"
                [attr.y]="68"
                text-anchor="middle"
              >
                {{ data.labels && data.labels[i] ? data.labels[i] : '' }}
              </text>
            </g>
          }
        </svg>
      </div>
    }

    @case('pie') {
      <div class="chart-frame">
        <svg viewBox="0 0 100 100" preserveAspectRatio="xMidYMid meet" class="chart-svg">
          @for (slice of pieSlices; track $index) {
            @let i = $index;
            <g>
              <path [attr.d]="slice.path" [attr.fill]="'hsl(' + (i * 60 % 360) + ',60%,60%)'"></path>
            </g>
          }
          @for (label of pieLabels; track $index) {
            <g>
              <text
                class="pie-label"
                [attr.x]="label.x"
                [attr.y]="label.y"
                text-anchor="middle"
                alignment-baseline="middle"
              >
                {{ label.text }}
              </text>
            </g>
          }
        </svg>
      </div>
    }

    @default {
      <div class="chart-frame no-data">No chart data</div>
    }
  }
</div>
